import React from 'react';
import { BaseButton, Typography } from 'fronton-react';
import { cn } from 'utils/classnames';
import { productName, productNameTextDefaultClass } from './styles';

type ProductNameProps = {
  href: string;
  className?: string;
} & React.AnchorHTMLAttributes<HTMLButtonElement>;

export const ProductName: React.FC<ProductNameProps> = ({
  href,
  children,
  onClick,
  onMouseDown,
  className,
}) => {
  return (
    <BaseButton
      onClick={onClick}
      onMouseDown={onMouseDown}
      href={href}
      className={productName}
      data-qa="product-name"
    >
      <Typography
        variant={'s'}
        size={'body_short'}
        color="text-primary"
        className={cn(productNameTextDefaultClass, className)}
      >
        {children}
      </Typography>
    </BaseButton>
  );
};
